import { render, staticRenderFns } from "./AdvancedTaxSettings.vue?vue&type=template&id=2d5873db&scoped=true&"
import script from "./AdvancedTaxSettings.vue?vue&type=script&lang=js&"
export * from "./AdvancedTaxSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5873db",
  null
  
)

export default component.exports